export const ELITE_QUESTION_TYPES = {
  MULTIPLE_CHOICE: 1,
  BOOLEAN: 2
};
export const ELITE_ANSWER_TYPES = {
  SINGLE_SELECT: 1,
  MULTI_SELECT: 2,
  SEQUENCE: 3
};
export const ELITE_QUIZ_TYPE = {
  QUIZ_ZONE: 1,
  MULTI_MATCH: 2,
  FUN_N_LEARN: 3,
  GUESS_THE_WORD: 4,
  AUDIO_QUESTIONS: 5,
  MATH_QUIZ: 6,
  CONTEST: 7,
  EXAM_MODULE: 8,
  DAILY_QUIZ: 9
};
export const GAME_LANGUAGES = [
  { value: 'english', name: 'English', label: 'English' },
  { value: 'german', name: 'German', label: 'German' },
  { value: 'french', name: 'French', label: 'French' },
  { value: 'arabic', name: 'Arabic', label: 'Arabic' },
  { value: 'portuguese', name: 'Portuguese', label: 'Portuguese' },
  { value: 'spanish', name: 'Spanish', label: 'Spanish' }
];
